<template>
  <div>
    <b-modal
      ref="userToken"
      centered
      size="lg"
      title="User Access Token"
      hide-footer
      @hidden="
        clearUserToken(),
        closeConfirmation()
      ">
      <template v-if="!userTokenEmpty">
        <b-alert
          show
          variant="light-info"
          class="mb-4">
          This token is used by users to obtain a list of servers and configs.
        </b-alert>
        <b-form
          id="userToken"
          inline
          class="w-100 mb-2">
          <b-form-input
            v-model="userToken"
            :disabled="usersResponses('regenerateUserToken')"
            id="userToken-input"
            readonly
            class="flex-grow-1 mr-auto" />
          <b-button
            id="copyUserTokenBtn"
            v-wave
            variant="primary"
            data-clipboard-target="#userToken-input"
            class="ml-2"
            :disabled="usersResponses('regenerateUserToken')">
            <i class="fa fa-copy fa-sm mr-1"></i>
            <span>Copy</span>
          </b-button>
        </b-form>
        <template v-if="confirmationShown">
          <b-alert
            show
            variant="light-danger"
            class="mb-0">
            <p class="mb-3">
              Wait, are you sure? Regeneration of the current access token will lead to loss of connection with the agent. Think twice before doing this!
            </p>
            <b-button
              @click="closeConfirmation"
              variant="outline-primary"
              size="sm">
              Cancel
            </b-button>
            <b-button
              variant="danger"
              size="sm"
              class="ml-4 text-center justify-content-center flex-grow-1"
              @click="confirmRegeneration(selectedUser._id), closeConfirmation()">
              <i class="fa fa-check fa-sm"></i>
              <span>Yes, regenerate token</span>
            </b-button>
          </b-alert>
        </template>
        <template v-else>
          <b-button
            variant="link-primary"
            class="mr-2"
            size="sm"
            @click="openConfirmation">
            <i class="fa fa-redo-alt fa-sm"></i>
            <span>Regenerate Token</span>
          </b-button>
        </template>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { REGENERATE_USER_TOKEN, CLEAR_USER_TOKEN } from '@/core/services/store/users.module'
import { mapGetters } from 'vuex'
import { eventBus } from '@/main'
import {
  showToast,
  showModal,
  hideModal,
  initClipboard,
  destroyClipboard,
} from '@/core/utils'

export default {
  name: 'ModalUserToken',
  data() {
    return {
      clipboard: null,
      confirmationShown: false,

      showToast,
      showModal,
      hideModal,
      initClipboard,
      destroyClipboard,
    }
  },
  computed: {
    ...mapGetters([
      'selectedUser',
      'selectedUserId',
      'userToken',
      'userTokenEmpty',
      'usersResponses',
    ]),
  },
  mounted() {
    eventBus.$on('openModal', type => {
      this.showModal(type)
    })

    this.initClipboard('copyUserTokenBtn')
  },
  destroyed() {
    eventBus.$off('openModal')

    this.destroyClipboard()
  },
  methods: {
    clearUserToken() {
      this.$store.commit(CLEAR_USER_TOKEN)
    },

    openConfirmation() {
      this.confirmationShown = true
    },

    closeConfirmation() {
      this.confirmationShown = false
    },

    confirmRegeneration(user_id) {
      this.$store.dispatch(REGENERATE_USER_TOKEN, { user_id })
    }
  }
}
</script>
